(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    (function () {
    function getVariantId(btn) {
      const form = btn.closest('form[data-type="add-to-cart-form"]');
      return form?.querySelector('[name="id"]')?.value || null;
    }

    function getQuantity(btn) {
      const form = btn.closest('form[data-type="add-to-cart-form"]');
      const qtyInput = form?.querySelector('.quantity-selector__input, [name="quantity"]');
      return qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    }

    async function handleBuyNow(btn) {
      const variantId = getVariantId(btn);
      if (!variantId) return;

      btn.disabled = true;
      btn.classList.add('buy-now-btn--loading');

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: parseInt(variantId, 10),
            quantity: getQuantity(btn),
          }),
        });

        if (!response.ok) throw new Error('Cart add failed');

        window.location.href = '/checkout';
      } catch {
        btn.disabled = false;
        btn.classList.remove('buy-now-btn--loading');
      }
    }

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.buy-now-btn');
      if (!btn) return;
      e.preventDefault();
      handleBuyNow(btn);
    });

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.sticky-buy-now-btn');
      if (!btn) return;
      e.preventDefault();
      const variantIdInput = document.querySelector('form[data-type="add-to-cart-form"] [name="id"]');
      if (!variantIdInput) return;

      const stickyBtn = btn;
      stickyBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: parseInt(variantIdInput.value, 10),
          quantity: 1,
        }),
      })
        .then((r) => {
          if (!r.ok) throw new Error('failed');
          window.location.href = '/checkout';
        })
        .catch(() => {
          stickyBtn.disabled = false;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
